import { isNonEmpty } from '@sgme/fp';
import type { CalendarInfo, CalendarType } from 'models/forms/fields/DateFieldMetadata';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getMonthlyExpiryCalendars } from 'state/selectors/common/misc';
import { intersect } from 'utils/array/array';

const EMPTY_CALENDARS: CalendarInfo[] = [];

export function useExpiryDates(calendarTypesToUse: CalendarType[], calendars: CalendarInfo[] = EMPTY_CALENDARS) {
  const monthlyExpiryCalendars = useSelector(getMonthlyExpiryCalendars);

  return useMemo(() => {
    const calendarsToBeUsed = calendars.filter(({ calendarType }) => calendarTypesToUse.includes(calendarType));
    const calendarExpiryDates = calendarsToBeUsed.map(({ id }) => (id ? monthlyExpiryCalendars[id] : []));

    return Array.from(
      new Set(
        calendarExpiryDates.reduce((agg, cur) => {
          const currentArray = isNonEmpty(cur) ? [...cur] : [];
          if (agg.length === 0) {
            return currentArray;
          }
          return intersect(agg, currentArray);
        }, []),
      ),
    );
  }, [calendarTypesToUse, calendars, monthlyExpiryCalendars]);
}
